import { PageTitle } from "@/components/page"
import { useDatabaseData, usePage } from "@/components/page/hooks"
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { ChatMessage, WhatsAppChat } from "@/components/whatsapp-chat/whatsappChat"
import { Plus, RefreshCcw, Trash2 } from "lucide-react"
import { usePermissions } from "@/lib/hooks/usePermissions"
import { useEffect, useMemo, useRef, useState } from "react"
import { supabase } from "@/lib/data"
import { ulid } from "ulid"
import { ContactEvaluationInfo } from "@/components/whatsapp-chat/contactevaluationInfo"
import { CRUDLoader } from "@/components/page/crudloader"

//Check user Raina Torphy!!!
//Check Dr. Rahsaan Stiedemann!!!

const simluatedAgent: Contact = {
  id: ulid(),
  type: "ai",
  name: "[Simulated]",
}

export function ContactsComponent() {

  const { navigate, team, } = usePage()
  const { canCreate, canDelete } = usePermissions()
  const { data: eval_items, loading: eval_items_loading } = useDatabaseData("eval_items")
  const [display, setDisplay] = useState<ContactTypes>("user")
  const [selectedContactId, setSelectedContactId] = useState<string | null>(null)
  const [loadingContacts, setLoadingContacts] = useState(true)
  const [contacts, setContacts] = useState<Contact[]>([])
  const [messages, setMessages] = useState<ChatMessage[]>([])
  const [messagesLoading, setMessagesLoading] = useState(false)
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)
  const virtualContacts = useRef({} as { [id: string]: Contact })

  async function loadContacts() {
    let query = supabase.from("contacts").select().eq("team", team?.id)
    let { data } = await query
    setContacts((data ?? []) as any)
  }

  useEffect(() => {
    if (team) {
      setMessages([])
      setSelectedContactId(null)
      setLoadingContacts(true)
      setLoadingContacts(false)
      loadContacts().then(() => setLoadingContacts(false))
    }
  }, [team])

  const finalListOfContacts = useMemo(() => {
    const finalContacts = contacts.filter(c => c.type === display)
    return finalContacts
  }, [contacts, display, team?.id])


  async function onRefreshContacts() {
    setMessages([])
    setSelectedContactId(null)
    setLoadingContacts(true)
    await loadContacts()
    setLoadingContacts(false)
  }

  async function onNewContact() {
    if (selectedContactId) {
      navigate(`/contacts/${selectedContactId}`)
    } else {
      navigate('/contacts/new')
    }
  }
  async function confirmDeleteMessages() {
    if (selectedContactId) {
      await supabase.from("messages").delete().eq("contact", selectedContactId)
      onContactSelected(selectedContactId)
      setDeleteDialogOpen(false)
    }
  }

  async function onContactSelected(id: string = null) {

    console.log(id)

    if (!id) {
      setSelectedContactId(null)
      setMessagesLoading(false)
      setMessages([])
      return
    }

    // const contact = contacts.find(c => c.id === id)
    // if (contact.type == "operator") {
    //   console.log(contact)
    // }


    setMessagesLoading(true)
    const { data, error } = await supabase.from("messages").select(`*, 
      agent(
        id,
        title
      )`).eq("contact", id).order("created_at", { ascending: true })

    console.log(data)

    const newMessages: ChatMessage[] = []

    if (data && data.length > 0) {
      const vcontacts = virtualContacts.current

      for (const md of data) {
        const m: ChatMessage = { ...md } as any
        if (m.role == "assistant") {

          const agentContact = simluatedAgent
          const a: Agent = m.agent as any
          if (a) {
            agentContact.id = `${a.id}`
            agentContact.name = a.title
          }
          vcontacts[agentContact.id] = agentContact

          // const a: Agent = m.agent as any
          // const agentContact: Contact = {
          //   id: `${a.id}`,
          //   name: a.title,
          //   type: "ai",
          // }
          // vcontacts[a.id] = agentContact

          m.contactObject = agentContact
          m.direction = "right"
        } else {
          m.contactObject = contacts.find(c => c.id === m.contact)
          m.direction = "left"
        }
        newMessages.push(m)
      }
    }
    setMessages(newMessages)
    setMessagesLoading(false)
    setSelectedContactId(id)
  }

  function onDisplayChange(v: string) {
    const type = v as ContactTypes
    setSelectedContactId(null)
    setMessages([])
    setDisplay(type)
  }

  let contact = contacts.find(c => c.id == selectedContactId)
  contact = contact && contact.type == "user" ? null : contact

  const items: Record<string, Evaluation_Item> = {}
  for (const item of eval_items) {
    items[item.id] = item as any
  }

  if (eval_items_loading) return <CRUDLoader />


  return <>
    <AlertDialog open={deleteDialogOpen} onOpenChange={setDeleteDialogOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Messages</AlertDialogTitle>
          <AlertDialogDescription>Are you sure you want to delete all messages for this contact? This action cannot be undone.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={confirmDeleteMessages} className="bg-destructive text-destructive-foreground hover:bg-destructive/90">Delete</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
    <div className="flex flex-col h-full min-h-0 overflow-hidden p-4 gap-4">
      <div className="flex shrink-0">
        <PageTitle />
        <div className="grow"></div>
        <div className="flex items-center gap-4">
          {canCreate("contacts") && <div>
            <Button className="rounded-lg" onClick={onNewContact}>{selectedContactId ? "Edit Contact" : "New Contact"}</Button>
          </div>}
          {canDelete("contacts") && <div>
            {contact && contact.type == "operator" && <Button className="rounded-lg" variant="destructive" onClick={() => setDeleteDialogOpen(true)}>Delete Messages</Button>}
          </div>}
          <div title="Refresh">
            <RefreshCcw className="h-8 w-8 text-muted-foreground cursor-pointer" onClick={onRefreshContacts} />
          </div>
        </div>
      </div>
      <div className="flex-1 min-h-0">
        <WhatsAppChat
          className="h-full"
          contacts={finalListOfContacts}
          messages={messages}
          selectedContactId={selectedContactId}
          onContactSelected={onContactSelected}
          loadingContacts={loadingContacts}
          loadingMessages={messagesLoading}
          hideContactName={contact?.type != "user"}
        >
          <WhatsAppChat.Toolbar>
            <div className="flex w-full items-center pb-1 ">
              <div className="">{contacts.length} Contacts</div>
              <div className="grow"></div>
              <div className="flex items-center">
                <div className="text-muted-foreground">Display:</div>
                <Select value={display} onValueChange={onDisplayChange}>
                  <SelectTrigger className="h-6 border-none shadow-none focus:outline-hidden focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0 w-28">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="user">User</SelectItem>
                    <SelectItem value="operator">Operator</SelectItem>
                    <SelectItem value="synthetic">Synthetic</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </WhatsAppChat.Toolbar>

          {contact?.type != "user" && <WhatsAppChat.ContactInfo>
            <ContactEvaluationInfo contact={contact} items={items} />
          </WhatsAppChat.ContactInfo>}


          <WhatsAppChat.MessageInput>
            <div />
          </WhatsAppChat.MessageInput>


        </WhatsAppChat>
      </div>
    </div>
  </>
}
